export const getVinhoVerdeData = () => ({
  name: "Vinho Verde",
  country: "Portugal",
  description: "Le Vinho Verde est la grande région du nord-ouest, célèbre pour ses vins blancs frais, légers et légèrement perlants, parfaits pour l'été.",
  type: "region",
  subregions: [
    { name: "Monção e Melgaço", area: "4,000 ha", percentage: "12%", description: "Berceau de l'Alvarinho" },
    { name: "Lima", area: "5,000 ha", percentage: "15%", description: "Vins frais et floraux" },
    { name: "Cávado", area: "6,000 ha", percentage: "18%", description: "Vins fruités" },
    { name: "Ave", area: "4,000 ha", percentage: "12%", description: "Vins légers" },
    { name: "Sousa", area: "5,000 ha", percentage: "15%", description: "Vins souples" },
    { name: "Basto", area: "3,000 ha", percentage: "9%", description: "Vins de montagne" },
    { name: "Amarante", area: "3,000 ha", percentage: "9%", description: "Vins fruités" },
    { name: "Paiva", area: "4,000 ha", percentage: "10%", description: "Vins de terroir" }
  ],
  mapAreas: [
    { region: "Monção e Melgaço", x: 34, y: 18, color: "#4B164C", size: 4 },
    { region: "Lima", x: 36, y: 20, color: "#6d2c7a", size: 5 },
    { region: "Cávado", x: 38, y: 22, color: "#8a4a8a", size: 6 },
    { region: "Ave", x: 40, y: 24, color: "#a768a6", size: 4 },
    { region: "Sousa", x: 42, y: 26, color: "#c486c4", size: 5 },
    { region: "Basto", x: 44, y: 28, color: "#e2a4e2", size: 3 },
    { region: "Amarante", x: 46, y: 30, color: "#f0c2f0", size: 3 },
    { region: "Paiva", x: 48, y: 32, color: "#f8e0f8", size: 4 }
  ],
  statistics: {
    totalArea: "34,000 ha",
    production: "1,200,000 hl",
    wineries: "600+ quintas",
    appellations: "8 sous-régions",
    exportPercentage: "40%"
  },
  characteristics: {
    climate: "Climat atlantique humide, précipitations abondantes",
    soil: "Sols granitiques, sables, argiles",
    viticulture: "Pergolas traditionnelles, vendanges précoces"
  },
  wineStyles: {
    white: "Blancs frais, légers, légèrement perlants (Alvarinho, Loureiro, Trajadura)",
    red: "Rouges légers, acidulés, production limitée"
  },
  history: "Le Vinho Verde est une région historique, exportant ses vins vers l'Angleterre dès le Moyen Âge. Les vins blancs sont aujourd'hui les plus réputés.",
  foodPairing: "Poissons, fruits de mer, salades, cuisine estivale portugaise"
}); 